<template>
    <v-data-table :headers="headers" :items="holidays">
        <template v-slot:items="{ item }">
            <td>{{ item.HolidayName }}</td>
            <td>{{ item.Date }}</td>
            <td>
                <!-- <v-list-tile v-for="(alert, j) in item.Alerts" :key="j" @click="navigate(alert.Url)"> -->
                <template v-for="(region, i) in item.Regions">
                    <span :key="i">{{region.Region}}</span>
                    <template v-if="i+1 < item.Regions.length">, </template>
                </template>
            </td>
            <td>
                <v-btn color="primary" block @click="$emit('edit', item)">
                    <span>Edit</span>
                </v-btn>
            </td>
        </template>
    </v-data-table>
</template>

<script>
export default {
    props: {
        holidays: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            headers: [
                {
                    text: "Name",
                    value: "HolidayName",
                    sortable: false
                },
                {
                    text: "Date",
                    value: "Date",
                    sortable: true
                },
                {
                    text: "Jurisdiction",
                    value: "Regions",
                    sortable: false
                },
                {
                    text: "",
                    value: "",
                    sortable: false
                },
            ]
        }
    }
}
</script>